import React from "react"
import { Layout, Button } from "antd"
import { SunOutlined, MoonOutlined } from "@ant-design/icons"
import { useTheme } from "../../../context/ThemeProvider"
import { PrimaryLogo } from "../PrimaryLogo"
import type { MinimalShellProps } from "./MinimalShell.types"

const { Content } = Layout

export const MinimalShell: React.FunctionComponent<MinimalShellProps> = ({
  children,
}) => {
  const { isDark, toggleTheme } = useTheme()

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Content
        className="flex items-center justify-center p-6"
        style={{ minHeight: "100vh" }}
      >
        {/* Theme toggle button in top-right corner */}
        <div className="fixed top-4 right-4 z-10">
          <Button
            type="text"
            icon={isDark ? <SunOutlined /> : <MoonOutlined />}
            onClick={toggleTheme}
            title={isDark ? "Switch to light mode" : "Switch to dark mode"}
          />
        </div>

        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <PrimaryLogo width={150} />
          </div>

          {children}
        </div>
      </Content>
    </Layout>
  )
}
